import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";

import Stack from "@mui/material/Stack";
import { useAppContext } from '../../AppContext';
import { useTheme } from '@mui/material/styles';


function Title({ data, eventUrl }) {  
  
    const theme = useTheme();
    const { url, themeData, siteData,  themeLoading, siteLoading, themeError, siteError, changeUrl, updateThemeData, updateSiteData } = useAppContext();
    const [themeCss, setThemeCss] = useState(null);
    const [loading, setLoading] = useState(true);
  
    useEffect(()=>{
      let custom_css = themeData && themeData ? JSON.parse(themeData && themeData.custom_css): null;
      setThemeCss(custom_css)
      setLoading(false)
    }, [themeData]);

    const eventTitleCard = {
      '& h1': {
        fontFamily: themeCss && themeCss.theme_primary_font ? (themeCss.theme_primary_font).replace("+"," ") : '',
        fontSize: 26,
        color: theme.palette.primary.contrastText,
        fontWeight: 500,
        textTransform: 'capitalize !important',
        marginBottom: theme.spacing(0.5),
      },
      '& h5': {
          fontFamily: themeCss && themeCss.theme_body_font ? (themeCss.theme_body_font).replace("+"," ") : '',
          fontSize: 14,
          textTransform: 'capitalize',    
          color: theme.palette.primary.contrastText,         
          fontWeight: 400,    
        },
        '& h6': {
            fontFamily: themeCss && themeCss.theme_body_font ? (themeCss.theme_body_font).replace("+"," ") : '',
            fontSize: 16,
            color: theme.palette.primary.location,
            fontWeight: 400,    
        },  
    };

  return (
    <>            
      <Typography component="div" sx={eventTitleCard}>
        <Stack display="flex" justifyContent="space-between" flexDirection="row">
          <Typography component="div">
            <Typography variant="h1">{data.title.toLowerCase()}</Typography>
            <Typography variant="h6">{data.event_type ? data.event_type : ""}</Typography>
          </Typography>
          </Stack>
        </Typography>      
    </>
  );
}

export default Title;
